export const LeaveconfigCreate = `mutation CreateLeaveConfig($input: LeaveConfigurationsInput!) { 

  AddLeaveConfigurations(input: $input) { 

    success 

    message 

    leaveConfigurationsDetails { 

      id 

      name 

      totalDays 

      eligibleForInterns 

      minAccumulationInterns 

      maxAccumulationInterns 

      eligibleForProbation 

      minAccumulationProbation 

      maxAccumulationProbation 

      allowNegative 

      maxNegativeDays 

      maxConsecutiveDays 

      minAccumulationDays 

      maxAccumulationDays 

      isLeaveWithoutPay 

      lopFrom 

      proRataBasis 

      applyBefore 

      applyAfter 

      attachmentMandatory 

      active 

      accrualMethod 

      allocationDay 

      halfDayAllowed 

      carryOver 

      carryOverLimit 

      carryOverExpiry 

      expiryLimitDays 

      encashmentAllowed 

      maxEncashmentDays 

      encashmentFrom 

    } 

  } 

} `

export const LeaveconfigUpdate = `mutation UpdateLeaveConfig($id: ID!, $input: LeaveConfigurationsInput!) { 

  editLeaveConfigurations(id: $id, input: $input) { 

    success 

    message 

    leaveConfigurationsDetails { 

      id 

      name 

      totalDays 

      eligibleForInterns 

      minAccumulationInterns 

      maxAccumulationInterns 

      eligibleForProbation 

      minAccumulationProbation 

      maxAccumulationProbation 

      allowNegative 

      maxNegativeDays 

      maxConsecutiveDays 

      minAccumulationDays 

      maxAccumulationDays 

      isLeaveWithoutPay 

      lopFrom 

      proRataBasis 

      applyBefore 

      applyAfter 

      attachmentMandatory 

      active 

      accrualMethod 

      allocationDay 

      halfDayAllowed 

      carryOver 

      carryOverLimit 

      carryOverExpiry 

      expiryLimitDays 

      encashmentAllowed 

      maxEncashmentDays 

      encashmentFrom 

    } 

  } 

} `

export const GetByIdLeaveconfig = `query leaveConfigurationById($id: ID!) { 

  leaveConfigurationById(id: $id) { 

      id 

      name 

      totalDays 

      eligibleForInterns 

      minAccumulationInterns 

      maxAccumulationInterns 

      eligibleForProbation 

      minAccumulationProbation 

      maxAccumulationProbation 

      allowNegative 

      maxNegativeDays 

      maxConsecutiveDays 

      minAccumulationDays 

      maxAccumulationDays 

      isLeaveWithoutPay 

      lopFrom 

      proRataBasis 

      applyBefore 

      applyAfter 

      attachmentMandatory 

      active 

      accrualMethod 

      allocationDay 

      halfDayAllowed 

      carryOver 

      carryOverLimit 

      carryOverExpiry 

      expiryLimitDays 

      encashmentAllowed 

      maxEncashmentDays 

      encashmentFrom 

  } 

} `

export const Allleaveconfigquery = `query allLeaveConfigurations{ 

  allLeaveConfigurations { 

      id 

      name 

      totalDays 

      eligibleForInterns 

      minAccumulationInterns 

      maxAccumulationInterns 

      eligibleForProbation 

      minAccumulationProbation 

      maxAccumulationProbation 

      allowNegative 

      maxNegativeDays 

      maxConsecutiveDays 

      minAccumulationDays 

      maxAccumulationDays 

      isLeaveWithoutPay 

      lopFrom 

      proRataBasis 

      applyBefore 

      applyAfter 

      attachmentMandatory 

      active 

      accrualMethod 

      allocationDay 

      halfDayAllowed 

      carryOver 

      carryOverLimit 

      carryOverExpiry 

      expiryLimitDays 

      encashmentAllowed 

      maxEncashmentDays 

      encashmentFrom 

  } 

} `